import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { App as AntdApp } from "antd";
import App from "./App";

import * as Sentry from "@sentry/react";

import { ConfigProvider } from "antd";
import defaultTheme from "./themes/default";
import AntdAppConfig from "./AntdAppConfig";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queries/queryClient";

import store from "./store";
import { watchChunkErrors } from "./utils/lazyWithReload";

import {
  BrowserRouter as Router,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import { useEffect } from "react";

const isProduction = process.env.NODE_ENV === "production";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: isProduction ? "production" : "development",
  release: process.env.REACT_APP_VERSION,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["error"] }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

if (process.env.REACT_APP_SENTRY_DNS) {
  Sentry.lazyLoadIntegration("replayIntegration")
    .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
    .catch(() => {});
}

watchChunkErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //   <React.StrictMode>
  <ConfigProvider theme={defaultTheme}>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Router>
          <title>Taborminerals</title>
          <AntdApp style={{ height: "100%" }} {...AntdAppConfig}>
            <App />
          </AntdApp>
        </Router>
      </Provider>
    </QueryClientProvider>
  </ConfigProvider>
  //   </React.StrictMode>
);
